import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/auth/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginProvidersProvider"] */ "/app/auth/loginProvidersContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/auth/RsdPathnameCookie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Announcement/Announcement.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/bprogress/ProgressProviderApp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/cookies/CookieConsentMatomo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/snackbar/MuiSnackbarProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/config/RsdPluginContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RsdSettingsProvider"] */ "/app/config/RsdSettingsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserSettingsProvider"] */ "/app/config/UserSettingsContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material-nextjs/esm/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/styles/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/styles/RsdThemeProvider.tsx");
